package com.hyperether.goodjob.scenes.contacts.components

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.lazy.items
import androidx.compose.foundation.lazy.rememberLazyListState
import androidx.compose.material.Divider
import androidx.compose.material.MaterialTheme
import androidx.compose.material.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.MutableState
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextOverflow
import androidx.navigation.NavHostController
import com.hyperether.goodjob.models.Contact
import com.hyperether.goodjob.models.Site
import com.hyperether.goodjob.navigation.ContactDetails
import com.hyperether.goodjob.resources.Res
import com.hyperether.goodjob.resources.sites
import com.hyperether.goodjob.scenes.components.clickableWithPointer
import com.hyperether.goodjob.scenes.components.disableMouseDragScrollOnWeb
import com.hyperether.goodjob.scenes.components.verticalScrollbar
import com.hyperether.goodjob.util.toScaleDp
import com.hyperether.goodjob.util.toScaleSp
import com.hyperether.resources.stringResource

@Composable
fun ContactListWeb(
    contacts: List<Contact>,
    navHostController: NavHostController,
    searchQuery: MutableState<String>,
    sites: List<Site>
) {

    val itemsPerPage = 5
    val currentPage = remember { mutableStateOf(1) }
    val filteredContactsSearch = if (searchQuery.value.isNotBlank()) {
        contacts.filter { contact ->
            contact.name?.contains(searchQuery.value, ignoreCase = true) == true ||
                    contact.personName?.contains(
                        searchQuery.value,
                        ignoreCase = true
                    ) == true
        }
    } else {
        contacts
    }.sortedByDescending { it.createdAt }

    val startIndex = (currentPage.value - 1) * itemsPerPage
    val endIndex = (startIndex + itemsPerPage).coerceAtMost(filteredContactsSearch.size)
    val paginatedContacts = filteredContactsSearch.subList(startIndex, endIndex)

    Column(
        modifier = Modifier.fillMaxSize()
    ) {
        val listState = rememberLazyListState()
        LazyColumn(
            state = listState,
            modifier = Modifier
                .verticalScrollbar(listState)
                .disableMouseDragScrollOnWeb()
                .fillMaxWidth()
                .weight(1f),
        ) {
            items(filteredContactsSearch) { rowItem ->
                ContactListRow(
                    navHostController = navHostController,
                    rowItem = rowItem,
                    sites.filter { it.parentId == rowItem.id }.size
                )
            }
        }

//            Pagination(
//                list = filteredContactsSearch,
//                currentPage = currentPage.value,
//                itemsPerPage = itemsPerPage,
//                onPageChange = { page -> currentPage.value = page }
//            )
    }
}

@Composable
fun ContactListRow(
    navHostController: NavHostController,
    rowItem: Contact,
    numberOfSites: Int
) {
    Column(
        modifier = Modifier
            .fillMaxWidth()
            .clip(MaterialTheme.shapes.medium)
            .clickableWithPointer {
                rowItem.id?.let { navHostController.navigate(ContactDetails(it)) }
            },
        verticalArrangement = Arrangement.Center
    ) {
        Row(
            verticalAlignment = Alignment.CenterVertically,
            modifier = Modifier
                .fillMaxWidth()
                .padding(horizontal = 24.toScaleDp())
                .height(64.toScaleDp())
        ) {
            Column(
                modifier = Modifier.weight(0.9f),
                verticalArrangement = Arrangement.Center
            ) {
                Text(
                    text = rowItem.name.orEmpty(),
                    color = Color(0xFF34618E),
                    fontSize = 14.toScaleSp(),
                    fontWeight = FontWeight.Bold,
                    maxLines = 1,
                    overflow = TextOverflow.Ellipsis
                )
                if (rowItem.contactType?.isNotEmpty() == true)
                    Text(
                        text = rowItem.contactType.orEmpty(),
                        color = Color(0xFF323232),
                        fontSize = 14.toScaleSp(),
                        maxLines = 1,
                        overflow = TextOverflow.Ellipsis
                    )
            }

            Text(
                text = rowItem.email.orEmpty(),
                modifier = Modifier.weight(1.2f),
                color = Color(0xFF323232),
                fontSize = 14.toScaleSp(),
                maxLines = 1,
                overflow = TextOverflow.Ellipsis
            )
            Text(
                text = rowItem.addressObject?.address.orEmpty(),
                modifier = Modifier.weight(1.2f),
                color = Color(0xFF555555),
                fontSize = 14.toScaleSp(),
                maxLines = 2,
                overflow = TextOverflow.Ellipsis
            )
            Text(
                text = rowItem.phone.orEmpty(),
                modifier = Modifier.weight(0.8f),
                color = Color(0xFF555555),
                fontSize = 14.toScaleSp()
            )
            Text(
                text = rowItem.industry.orEmpty(),
                modifier = Modifier.weight(0.7f),
                color = Color(0xFF323232),
                fontSize = 14.toScaleSp()
            )
            Text(
                text = "$numberOfSites ${stringResource(Res.string.sites)}",
                modifier = Modifier.weight(0.5f),
                color = Color(0xFF34618E),
                fontSize = 14.toScaleSp(),
                fontWeight = FontWeight.Bold
            )
        }
        Divider(
            modifier = Modifier.fillMaxWidth().height(1.toScaleDp())
                .background(Color.LightGray.copy(alpha = 0.1f))
        )
    }
}
